// extracted by mini-css-extract-plugin
export default {"authorsView":"authors-view_authorsView__+wve8"};